/*
  willoway-custom.js
  Willoway Nurseries site-specific JS on top of the Keystone theme.
  Safe to edit -- separate from Keystone's compiled JS bundle.
*/

/* Fix #33: clicking a top-level nav button should not lock the mega-menu
   dropdown open. Keystone's compiled CSS keeps the dropdown visible while
   the button has :focus, and :focus persists after mouse-out. Blurring the
   button on mouse-initiated clicks removes :focus so CSS can close the
   dropdown normally. Keyboard clicks (event.detail === 0) are unaffected,
   preserving Tab/Enter accessibility. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (e.detail >= 1) { // mouse click; keyboard Enter/Space has detail === 0
        this.blur();
      }
    });
  });
});
/* Cross-store enforcement: stamp the selected B2B location onto every line
   at add-time as properties._store, so the cart remembers which store each
   item was picked from. Read back by cart-location-validator.js. */
(function () {
  function selectedStore() {
    try {
      var inv = window.Alpine && Alpine.store && Alpine.store('locationInventory');
      if (inv && inv.selectedLocation) return inv.selectedLocation;
    } catch (e) {}
    try { return localStorage.getItem('willoway:location') || ''; } catch (e) {}
    return '';
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var first = args[0];
    var url = '';
    if (typeof first === 'string') url = first;
    else if (first && typeof first.url === 'string') url = first.url;

        if (url.indexOf('/cart/add') !== -1) {
      console.log('[stamp] add intercepted, store =', selectedStore());
      var store = selectedStore();
      var store = selectedStore();
      if (store) {
        var opts = args[1];
        // JSON body path (addCartItem / editCartItem)
        if (opts && typeof opts.body === 'string') {
          try {
            var data = JSON.parse(opts.body);
            if (Array.isArray(data.items)) {
              data.items.forEach(function (it) {
                it.properties = it.properties || {};
                if (!it.properties._store) it.properties._store = store;
              });
            } else if (data.id) {
              data.properties = data.properties || {};
              if (!data.properties._store) data.properties._store = store;
            }
            opts.body = JSON.stringify(data);
          } catch (e) {}
        }
        // FormData body path (submitCartForm)
        else if (opts && opts.body instanceof FormData) {
          if (!opts.body.has('properties[_store]')) {
            opts.body.append('properties[_store]', store);
          }
        }
      }
    }
    return originalFetch.apply(null, args);
  };
})();